import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Label } from "@progress/kendo-react-labels";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import styles from "./index.module.scss";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { useState } from "react";
import { addDirector, updateDirector } from "api";
import { toast } from "react-toastify";
import { FormInput } from "components/Matters";
import SubmitButton from "components/common/SubmitButton";
import { Checkbox } from "@progress/kendo-react-inputs";

const DirectorForm = (props) => {
  const isEdit = !!props.editData;

  const [date, setDate] = useState(
    props.editData?.dateOfBirth ? new Date(props.editData.dateOfBirth) : new Date()
  );
  const [inputState, setInputState] = useState({
    First_Name: props.editData?.firstName || "",
    Last_Name: props.editData?.lastName || "",
  });
  const [isActive, setIsActive] = useState(true);
  const [isEdited, setIsEdited] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (value, label) => {
    setInputState({ ...inputState, [label]: value });
  };

  const isFirstNameEmpty = !inputState["First_Name"]?.trim();
  const isLastNameEmpty = !inputState["Last_Name"]?.trim();

  const handleSubmit = async () => {
    setSubmitted(true);
    if (isFirstNameEmpty || isLastNameEmpty) return;
    try {
      setIsSubmitting(true);
      if (isEdit) {
        const data = {
          companyPersonId: props.editData.companyPersonId,
          firstName: inputState["First_Name"],
          lastName: inputState["Last_Name"],
          dateOfBirth: date,
          personType: "director",
          ...(!isActive && { active: false }),
        };
        const resultData = await updateDirector({ data }, props.clientId, props.editData.companyPersonId);
        toast.success("Director Updated");
        props.onUpdateData(resultData?.data?.data);
      } else {
        const data = {
          firstName: inputState["First_Name"],
          lastName: inputState["Last_Name"],
          dateOfBirth: date,
          personType: "director",
        };
        const resultData = await addDirector({ data }, props.clientId);
        toast.success("Director Added");
        props.onUpdateData(resultData?.data?.data);
      }
      props.cancelEdit();
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      title={isEdit ? "Edit Director" : "Add Director"}
      onClose={props.cancelEdit}
      width={500}
      className="p-3"
    >
      <div className={`${styles["director-tile"]} p-2 m-4 ms-5 me-5`}>
        <div className="p-3 ps-4">
          <div className={`form-date-picker note-date-picker mt-2${submitted && isFirstNameEmpty ? " validation-invalid" : ""}`}>
            <FormInput
              className={"form-date-picker note-date-picker "}
              wf={true}
              isStyled={true}
              width={"260px"}
              label={"First_Name"}
              onChangeInput={handleInputChange}
              state={inputState}
            />
          </div>

          <div className={`mt-3 ${submitted && isLastNameEmpty ? "validation-invalid" : ""}`}>
            <FormInput
              className={"form-date-picker note-date-picker "}
              wf={true}
              isStyled={true}
              width={"260px"}
              label={"Last_Name"}
              onChangeInput={handleInputChange}
              state={inputState}
            />
          </div>

          <div className="form-date-picker note-date-picker mt-3">
            <Label className="label mt-1 mb-1 w-100">Date of Birth</Label>
            <DatePicker
              toggleButton={(props) => (
                <CalenderCustomToggleButton
                  {...props}
                  show={date !== null && date !== undefined}
                  onCancel={() => setDate(null)}
                />
              )}
              onChange={(e) => setDate(e.value)}
              value={date}
              className="px-1"
              style={{ height: "32px", width: "260px" }}
            />
          </div>

          {isEdit && (
            <div className="mt-3">
              <Checkbox
                name="active"
                label="Active"
                value={isActive}
                onChange={(e) => setIsActive(e.value)} />
            </div>

          )}
        </div>
      </div>
      <div className="dialog-footer">
        <button
          className="bgBtnSecondary common-btn me-2"
          onClick={() => {
            if (isEdited) {
              setIsEdited(false);
            } else {
              props.cancelEdit();
            }
          }}
        >
          Cancel
        </button>
        <SubmitButton
          className="me-3"
          isLoading={isSubmitting}
          onClick={() => {
            handleSubmit();
          }}
        >
          {isEdit ? "Update" : "Save"}
        </SubmitButton>
      </div>
    </Dialog>
  );
};

export default DirectorForm;
